export const TYPE_TRACKING = {
  pageOpen: "pageOpen",
  userInfo: "userInfo",
  applyJob: "applyJob",
  skipJob: "skipJob",
  displayJob: "displayJob",
  click:"click"
};